import { render, staticRenderFns } from "./Pointer.vue?vue&type=template&id=30ec835f"
import script from "./Pointer.vue?vue&type=script&lang=js"
export * from "./Pointer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports